var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-container"},[_c('div',{staticClass:"image"}),_c('div',{staticClass:"text-container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('hero.title')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }